import { Input, Component, OnInit } from '@angular/core';

@Component({
    selector: 'checkbox-wrap',
    template: `
  <label class="t-checkbox" (click)="stopClickPropagation($event)" [title]="labelTitle">
    <span class="l-align-y">
      <ng-content></ng-content>
      <i class="fa t-checkbox-appearance" [ngStyle]="boxStyle"></i>
      <span class="t-chackbox-labeText" [ngClass]="labelClass" [ngStyle]="labelStyle">
        <i *ngIf="icon" class="fas" [ngClass]="'fa-' + icon"></i>
        {{label}}
      </span>
      <ng-content select="[customLabel]"></ng-content>
    </span>
  </label>
`,
    standalone: false
} )
export class CheckboxWrapComponent implements OnInit {

  @Input() label: string;
  @Input() labelTitle: string;
  @Input() icon: string;
  @Input() stopPropagation: boolean = false;
  @Input() labelClass!: string | string[] | Set<string> | { [klass: string]: any };
  @Input() labelStyle!: { [key: string]: any };
  @Input() boxStyle!: { [key: string]: any };

  constructor() {}

  ngOnInit() {
  }
  stopClickPropagation(event: MouseEvent) {
  if (this.stopPropagation) {
     event.stopPropagation();
   }
  }
}
